import { useState } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import DropZone from "../dropzone";
import { IFiles } from "../../../config/interfaces";
import { useUploadCreativeDocumentMutation } from "../../../../graphql/generated/graphql";
import { setAlertDescription } from "../../../hooks/actions";
import "./index.scss";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 900,
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "20px",
  p: 4,
  pb: 4,
};

const DropZoneModal = (props: any) => {
  const { open, onClose, refetch, setIsLoadingDocs } = props;
  const params = useParams();
  const [title, setTitle] = useState<string>("");
  const [link, setLink] = useState<string>("");
  const [uploadFiles] = useUploadCreativeDocumentMutation();

  const saveFiles = async (type: string, jsonFile?: IFiles) => {
    setIsLoadingDocs(true);
    closeDocModal();
    const files: IFiles[] = []
    if (type === 'link') {
      files.push({ name: title, link_url: link, base64: '' })
    } else if (type === 'file') {
      if (jsonFile) {
        files.push({ name: jsonFile.name, base64: jsonFile.base64, link_url: '' })
      }
    }
    try {
      await uploadFiles({
        variables: {
          project_id: params.projectId ?? '',
          documents: files.map((f) => ({
            file_name: f.name,
            document: f.base64 || undefined,
            link_url: f.link_url || undefined,
          })),
        },
      }).then((res) => {
        setIsLoadingDocs(false);
        setAlertDescription({
          open: true,
          message: 'The File/Link has been uploaded succesfully',
          severity: 'success',
        })
        if (res.data?.uploadCreativeDocument) {
          setTitle('');
          setLink('');
          if (refetch) {
            refetch();
          }
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  const closeDocModal = () => {
    setTitle("");
    setLink("");
    onClose();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <>
            <Grid container>
              <IconButton onClick={closeDocModal}>
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                md={5}
                className='dropzone-grid'
              >
                <Box
                >
                  <DropZone handleZone={saveFiles} />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={2}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    height: "72%",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      color: "#9CA3AF",
                      height: "60%",
                    }}
                  >
                    <Box
                      sx={{
                        borderLeft: "1px solid #9CA3AF",
                        flexGrow: 1,
                        width: "1px",
                      }}
                    />
                    <Box>Or</Box>
                    <Box
                      sx={{
                        borderLeft: "1px solid #9CA3AF",
                        flexGrow: 1,
                        width: "1px",
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
              >

                <Box
                  sx={{
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  <Typography
                    component="p"
                    variant="h2"
                  >
                    Add to link
                  </Typography>
                  <Typography component="p">Description...</Typography>
                  <TextField
                    margin="normal"
                    fullWidth
                    name="title"
                    label="Title"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  <TextField
                    margin="normal"
                    fullWidth
                    name="link"
                    label="Link"
                    id="link"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      saveFiles('link')
                      closeDocModal()
                    }}
                  >
                    Add link
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </>
        </Box>
      </Box>
    </Modal>
  );
};
export default DropZoneModal;
